export default __webpack_public_path__ + "static/media/kycDetails.ec88b4f2.png";